import CommonDefaults from './CommonDefaults';
import ConstituentField from './ConstituentField';

const OrgDefaults = Object.freeze({
  ...CommonDefaults,
  [ConstituentField.ORG_NAME]: '',
  [ConstituentField.INDUSTRY]: '',
  [ConstituentField.CATEGORY_CORPORATION]: false,
  [ConstituentField.CATEGORY_FOUNDATION]: false,
  [ConstituentField.CATEGORY_GOVERNMENT]: false,
});

export default OrgDefaults;
